var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import translations from '../core/translations';
import cloneDeep from '../core/utils/cloneDeep';
var translationObject = __assign({}, translations);
var defaultLang = 'nl';
// Helper for rendering the text
var renderText = function (key, arg) {
    if (!key || key.length <= 1) {
        return '';
    }
    // Construct the path as an array
    var path = key.split('.');
    // get the value we need
    var translation = __assign({}, translationObject[defaultLang]);
    // Use the path to go through the object.
    if (path && path.length > 0) {
        path.forEach(function (translationKey) {
            translation = translation && translation[translationKey];
        });
    }
    // If no translation found, return the key string, to show it's broken.
    if (!translation) {
        return key;
    }
    // Static translations
    if (typeof translation === 'string') {
        return translation;
    }
    // Return the translation, execute it so we can pass dynamic values.
    return translation(arg);
};
var onMount = function (config) {
    window._mensenlinqText = window._mensenlinqText || config || {};
    return window._mensenlinqText;
};
// Init function to override the text
renderText.init = function (config, overwriteLang) {
    var languageOverwrites = onMount(config);
    // NL / ES / EN / DL etc
    if (overwriteLang) {
        defaultLang = overwriteLang;
    }
    window._mensenlinqLang = window._mensenlinqLang || defaultLang || 'en';
    // Clone the default translations to remove the reference
    var clonedDefaultText = cloneDeep(translations);
    //
    //
    // Footer
    if (languageOverwrites === null || languageOverwrites === void 0 ? void 0 : languageOverwrites.en) {
        clonedDefaultText.en = __assign(__assign(__assign({}, clonedDefaultText.en), (languageOverwrites.en || {})), { footer: __assign(__assign({}, clonedDefaultText.en.footer), (languageOverwrites.en.footer || {})), feed: __assign(__assign({}, clonedDefaultText.en.feed), (languageOverwrites.en.feed || {})), search: __assign(__assign({}, clonedDefaultText.en.search), (languageOverwrites.en.search || {})) });
    }
    if (languageOverwrites === null || languageOverwrites === void 0 ? void 0 : languageOverwrites.nl) {
        clonedDefaultText.nl = __assign(__assign(__assign({}, clonedDefaultText.nl), (languageOverwrites.nl || {})), { footer: __assign(__assign({}, clonedDefaultText.nl.footer), (languageOverwrites.nl.footer || {})), feed: __assign(__assign({}, clonedDefaultText.nl.feed), (languageOverwrites.nl.feed || {})), search: __assign(__assign({}, clonedDefaultText.nl.search), (languageOverwrites.nl.search || {})) });
    }
    //
    //
    // Return
    translationObject = clonedDefaultText;
};
renderText.returnConfig = function () {
    return translationObject;
};
export default renderText;
